import { keyframes } from '@emotion/react';
import type { NotificationKind, NotificationPositionType } from './types';
import { NotificationPosition } from './types';
import { semantic_colors } from '../../foundation';

export const notification_kind_css: Record<NotificationKind, string> = {
  info: semantic_colors.accent.primary,
  success: semantic_colors.state.positive,
  error: semantic_colors.state.negative,
  warning: semantic_colors.state.warning,
};

export const notification_hide_animation = (position: NotificationPositionType) => {
  switch (position) {
    case NotificationPosition.TOP_CENTER:
    case NotificationPosition.BOTTOM_CENTER:
    case NotificationPosition.CENTER:
      return keyframes`
          to {
            transform: translateY(0);
            opacity: 1;
          }
          from {
            transform: translateY(170px);
            opacity: 0;
          }
        `;
    case NotificationPosition.TOP_RIGHT:
    case NotificationPosition.BOTTOM_RIGHT:
      return keyframes`
        to {
          transform: translateX(0);
          opacity: 1;
        }
        from {
          transform: translateX(170px);
          opacity: 0;
        }
      `;
  }
};
